import { useMemo } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../config";
import { API_WEB_PATH, WEB_PATH } from "../../constant";
import useCasinoType from "../../hook/useCasinoType";

const CommonHelmet = () => {
  const casinoType = useCasinoType();

  const { title, description } = useMemo(() => {
    let newTitle = "911win - Nhà cái Uy tín Nhất - Giải trí trực tuyến";
    let newDescription =
      "911win trang cá cược uy tín hàng đầu Châu Á. Nơi bạn có thể chơi Live Casino, Game bài, Cá cược Thể Thao, Đá gà, Bắn Cá, Xổ Số Online.";

    if (casinoType === "sports") {
      newTitle = "911win Cá Cược Thể Thao Trực Tuyến - Giải trí trực tuyến";
      newDescription =
        "911win Cá cược thể thao hàng đầu,Bóng đá toàn cầu, tỷ lệ cược cao nhất";
    }
    if (casinoType === "lottery") {
      newTitle = "911win Xổ Số Trực Tuyến - XSMB,XSMT";
      newDescription =
        "911win Xổ Số Việt Nam. Hội viên nạp 700K lần đầu tặng ngay 700K";
    }
    if (casinoType === "live-casino") {
      newTitle = "911win Casino Trực Tuyến - live casino, baccarat";
      newDescription =
        "911win Các sảnh casino trực tuyến hàng đầu. Đánh bài Baccarat, Blackjack, Sicbo thắng tiền thật. Hoàn trả lên tới 0.8%";
    }
    if (casinoType === "promotion") {
      newTitle = "911win Casino trực tuyến - Khuyến mãi - Phục vụ 24/24";
      newDescription =
        "911win khuyến mãi đa dạng để thêm cơ hội chiến thắng. Thưởng gửi tiền, hoàn tiền, quà tặng chào mừng, các giải thưởng lớn và điểm thưởng không giới hạn!";
    }

    return { title: newTitle, description: newDescription };
  }, [casinoType]);

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta content="website" property="og:type" />
      <meta
        property="og:title"
        content="911win - Trang cá cược, website casino uy tín số #1 châu Á."
      />
      <meta
        property="og:description"
        content="Nền tảng giải trí trực tuyến tốt nhất, tốc độ rút tiền nhanh, dịch vụ khách hàng 24 giờ, đa dạng chỉ có tại 911win."
      />
      <meta
        property="og:image"
        content="https://www.911win.co/images/ch/911vlogo_153x56.png"
      />
      <meta property="og:url" content="http://www.911win.co" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, user-scalable=0"
      ></meta>
      <link rel="icon" href={`${API_WEB_PATH}/logo_144.png`} />
    </Helmet>
  );
};

export default CommonHelmet;
